import * as React from 'react';

import { lazyWithPreload } from '../../navigation';

/**
 * We lazy load the insights components as they include large datasets.
 */
export const SiteAnalyticsLinkUsageButton = React.lazy(async () => {
    const { SiteAnalyticsLinkUsageButton } = await import('./index.lazy');
    return { default: SiteAnalyticsLinkUsageButton };
});

export const BrokenURLVisitsReport = React.lazy(async () => {
    const { BrokenURLVisitsReport } = await import('./NewBrokenURLs/BrokenURLVisitsReport');
    return { default: BrokenURLVisitsReport };
});

export const SiteNewAnalyticsTrafficReport = React.lazy(async () => {
    const { SiteNewAnalyticsTrafficReport } = await import('./index.lazy');
    return { default: SiteNewAnalyticsTrafficReport };
});

export const SiteNewAnalyticsAgentsReport = React.lazy(async () => {
    const { SiteNewAnalyticsAgentsReport } = await import('./index.lazy');
    return { default: SiteNewAnalyticsAgentsReport };
});

export const SiteNewAnalyticsBrokenURLsReport = lazyWithPreload(async () => {
    const { SiteNewAnalyticsBrokenURLsReport } = await import('./index.lazy');
    return { default: SiteNewAnalyticsBrokenURLsReport };
});

export const SiteNewAnalyticsAdsReport = React.lazy(async () => {
    const { SiteNewAnalyticsAdsReport } = await import('./index.lazy');
    return { default: SiteNewAnalyticsAdsReport };
});

export const SiteNewAnalyticsEngagementReport = React.lazy(async () => {
    const { SiteNewAnalyticsEngagementReport } = await import('./index.lazy');
    return { default: SiteNewAnalyticsEngagementReport };
});

export const SiteNewAnalyticsAssistantReport = React.lazy(async () => {
    const { SiteNewAnalyticsAssistantReport } = await import('./index.lazy');
    return { default: SiteNewAnalyticsAssistantReport };
});

export const AssistantScopeProvider = React.lazy(async () => {
    const { AssistantScopeProvider } = await import('./index.lazy');
    return { default: AssistantScopeProvider };
});

export const SiteAnalyticsQueryChart = React.lazy(async () => {
    const { SiteAnalyticsQueryChart } = await import('./index.lazy');
    return { default: SiteAnalyticsQueryChart };
});

export * from './analyticsChartSeries';
export * from './AnalyticsRangeButton';
// Only its content is lazy: the panel renders a skeleton while the analytics chunk loads.
export { SiteAnalyticsOverview } from './SiteAnalyticsOverview';
export * from './AnalyticsReportMain';
export * from './AnalyticsToolbarActions';
export * from './dateRangeUtils';
export { getBrokenURLFilters } from './NewBrokenURLs/queries';
export { toAnalyticsTotals } from './Report/data';
export { analyticsTotalsAggregation } from './Report/queries';
export { siteEventsAggregationQuery } from './queries';
export * from './SiteNewAnalyticsBreadcrumbPicker';
export * from './state';
export * from './tracking';
